import {useFormik} from 'formik';
import {useSchemes} from '../../../shared';
import {useState} from 'react';
import {useBenefactorById, BenefactorModel} from '../../../entities';
import * as Yup from 'yup';
import {AxiosError} from 'axios';

type UseEditBenefactorPhoneFormProps = {
  setOpen: (open: boolean) => void;
  benefactorId: string;
  benefactor?: BenefactorModel;
};

export const useEditBenefactorPhoneForm = ({setOpen, benefactorId, benefactor}: UseEditBenefactorPhoneFormProps) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const {updateBenefactorPhoneMutation} = useBenefactorById(benefactorId);
  const {phoneNumberSchema} = useSchemes();

  const onSubmit = async (values: {phoneNumber: string}) => {
    setErrorMessage(null);
    try {
      await updateBenefactorPhoneMutation.mutateAsync({benefactorId, phoneNumber: values.phoneNumber});
      setOpen(false);
    } catch (error) {
      console.error(error);
    }
  };

  const formik = useFormik({
    initialValues: {
      phoneNumber: benefactor?.phoneNumber || '',
    },
    validationSchema: Yup.object({
      phoneNumber: phoneNumberSchema,
    }),
    onSubmit,
    enableReinitialize: true,
  });

  return {
    ...formik,
    isLoading: updateBenefactorPhoneMutation.isPending,
    errorMessage,
    submitError: updateBenefactorPhoneMutation.error ? (updateBenefactorPhoneMutation.error as AxiosError<ApiError>)?.response?.data : null,
    submitForm: () => formik.handleSubmit(),
  };
};
